import { APIUrlConstants, AppConstants } from '../../../common/APIConstants';
import RestEndPoint from '../../../common/RestEndPoint';

export default class NominationDataService {
  static getNominationData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetNominationData,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
  static saveNominationData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.SaveNominationData,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
  static getNominationAudit(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetNominationAudit,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
}